(() => {
  if (window.Shopify?.designMode) return;

  const delay = 5 * 60 * 1000;
  const startedKey = 'order-help-chat:started';
  const shownKey = 'order-help-chat:shown';
  const read = (key) => {
    try { return sessionStorage.getItem(key); } catch { return null; }
  };
  const write = (key, value) => {
    try { sessionStorage.setItem(key, String(value)); } catch {}
  };

  if (read(shownKey)) return;
  const now = Date.now();
  const savedStart = Number(read(startedKey));
  const started = savedStart > 0 && savedStart <= now ? savedStart : now;
  write(startedKey, started);

  let chat;
  let timer;
  let finished = false;
  let chatObserver;
  const discovery = new MutationObserver(connect);

  function finish() {
    finished = true;
    write(shownKey, '1');
    clearTimeout(timer);
    discovery.disconnect();
    chatObserver?.disconnect();
    document.removeEventListener('visibilitychange', attempt);
  }

  function attempt() {
    if (finished || !chat) return;
    if (read(shownKey) || chat.hasAttribute('open')) {
      finish();
      return;
    }
    if (Date.now() - started < delay || document.visibilityState !== 'visible') return;
    finish();
    chat.setAttribute('open', '');
  }

  function connect() {
    if (finished || chat) return;
    chat = document.querySelector('shopify-chat');
    if (!chat) return;
    discovery.disconnect();
    chatObserver = new MutationObserver(attempt);
    chatObserver.observe(chat, { attributes: true, attributeFilter: ['open'] });
    attempt();
  }

  document.addEventListener('visibilitychange', attempt);
  timer = setTimeout(attempt, Math.max(0, delay - (Date.now() - started)));
  customElements.whenDefined('shopify-chat').then(() => {
    if (finished) return;
    discovery.observe(document.documentElement, { childList: true, subtree: true });
    connect();
  });
})();
